import User from "../entities/User";

const LOCAL_STORAGE_TOKEN_NAME = 'AUTH';

class Token {
    public value?: string;

    constructor() {
        this.value = localStorage.getItem(LOCAL_STORAGE_TOKEN_NAME) || undefined;
    }

    save() {
        localStorage.setItem(LOCAL_STORAGE_TOKEN_NAME, this.value || '');
    }

    replace(value: string) {
        this.value = value;
        this.save();
    }

    remove() {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN_NAME)
    }

    parse(): User | undefined {
        try {
            const base64Url = this.value?.split('.')[1];
            const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64 || '').split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const parsed = JSON.parse(jsonPayload);
            const ids = parsed.sub.split("~")
            return new User(ids[1],ids[0], parsed.name, parsed.email, parsed.roles, parsed.isRoot);
        } catch (e) {
            return undefined;
        }
    }
}

export default Token;